import { Box, Checkbox, Collapse, IconButton, Stack, TableCell, TableRow } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { createSlot } from "lib/@components/slot/create-slot"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import Iconify from "minimals-template/components/Iconify"
import { useState } from "react"
import { ScheduleSummary } from "routes/schedule/plugins/ai-summary/ai-summary.runtime"
import { If } from "lib/@components/switch"
import { ExpandSchedule } from "../expand-schedule"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { useDemand } from "lib/authorization/use-demand"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export const ScheduleRowCell = createSlot("ScheduleRowCell")

export function AddGroupScheduleRow({ schedule, selected = {}, handleSelect }) {
    const { title, code, id } = schedule
    const { projectGroup } = useBoundContext()
    const canEditSchedule = useDemand(AUTHORING_EDIT_SCHEDULES_DEMAND)
    const filteredTasks = schedule?.tasks?.filter(({ isHeader }) => !isHeader)
    const taskCount = filteredTasks?.length ?? 0
    const [showMore, setShowMore] = useState(false)
    const selectionCheckbox = canEditSchedule ? (
        <BlockClicks>
            <Checkbox checked={!!selected[id]} onClick={() => handleSelect(id)} disabled={projectGroup.readOnly} />
        </BlockClicks>
    ) : null
    const scheduleActions = canEditSchedule ? <ScheduleRowCell.Slot /> : null

    return (
        <Bound targetId={id} schedule={schedule} taskCount={taskCount}>
            <TableRow
                onClick={() => setShowMore((show) => !show)}
                data-cy="add-group-schedule-row"
                hover
                sx={{ cursor: "pointer" }}
            >
                <TableCell sx={{ width: 50, maxWidth: 50, whiteSpace: "noWrap" }}>{selectionCheckbox}</TableCell>
                <TableCell sx={{ whiteSpace: "noWrap", maxWidth: { md: 450 } }}>
                    <Stack direction={"row"} alignItems={"center"} spacing={1}>
                        <Iconify icon={"quill:paper"} sx={{ width: 25, height: 25 }} />
                        <TruncatedTypography>{title}</TruncatedTypography>
                        <ScheduleSummary id={id} />
                    </Stack>
                </TableCell>
                <TableCell>#{code}</TableCell>
                <TableCell align="right">{taskCount}</TableCell>
                <TableCell sx={{ width: 50, maxWidth: 50, whiteSpace: "noWrap", py: 0 }}>
                    <IconButton
                        aria-label={showMore ? "Hide schedule details" : "Show schedule details"}
                        data-cy="show-schedule-details"
                    >
                        <Iconify icon={showMore ? "mingcute:up-fill" : "mingcute:down-fill"} />
                    </IconButton>
                </TableCell>
                <TableCell sx={{ width: 70, maxWidth: 70, whiteSpace: "noWrap", py: 0 }}>{scheduleActions}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={6} sx={{ p: 0 }}>
                    <Box sx={{ overflow: "hidden" }}>
                        <Collapse in={showMore} mountOnEnter sx={{ width: 1 }}>
                            <If truthy={!!schedule.id}>
                                <ExpandSchedule expandedSchedule={schedule} />
                            </If>
                        </Collapse>
                    </Box>
                </TableCell>
            </TableRow>
        </Bound>
    )
}
